import { Component, OnInit } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-basic',
    templateUrl: './form-factory-field-basic.component.html',
    styleUrls: ['./form-factory-field-basic.component.scss'],
})
export class FormFactoryFieldBasicComponent extends FormFieldFactoryComponentAbstract {}
